import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {TextPlugin} from 'gsap/TextPlugin'
// import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(SplitText)
gsap.registerPlugin(TextPlugin) 

export default class Animations {
  static init() {
    console.debug('== Animations components ==')

    // General animations
    console.debug('  -> Animate general components')

    // const animateHero = document.querySelectorAll('#hero-explosion')
    const animateHero = document.querySelectorAll('.animate-out-away')
    if (animateHero.length != 0) {
      animateScrollHero(animateHero)
    }

    const animateRight = document.querySelectorAll('.animate-right')
    if (animateRight.length != 0) {
      animateHorizontal(animateRight, 20)
    }

    const animateLeft = document.querySelectorAll('.animate-left')
    if (animateLeft.length != 0) {
      animateHorizontal(animateLeft, -20)
    }

    const animateBottom = document.querySelectorAll('.animate-bottom')
    if (animateBottom.length != 0) {
      animateVertical(animateBottom, 20)
    }

    const animateTop = document.querySelectorAll('.animate-top')
    if (animateTop.length != 0) {
      animateVertical(animateTop, -20)
    }

    const animateFadeItems = document.querySelectorAll('.animate-fade')
    if (animateFadeItems.length != 0) {
      animateFade(animateFadeItems)
    }

    const animateBottomStagger = document.querySelectorAll('.animate-bottom-stagger')
    if (animateBottomStagger.length != 0) {
      animateInStaggerBottom(animateBottomStagger, 20, 0.15)
    }
  }

  static destroyScrolls() {
    ScrollTrigger.killAll()
  }
}

// OLD ANIMATION
// let scrollingFromAnchor = false

// document.addEventListener("click", function (event) {
//   const anchor = event.target.closest("a[href^='#']")
//   if (anchor) {
//     scrollingFromAnchor = true

//     setTimeout(() => {
//       scrollingFromAnchor = false
//     }, 1000)
//   }
// })

// function isScrollingFromAnchor() {
//   return scrollingFromAnchor
// }

// function scrollToSection(selector) {
//   let target = document.querySelector(selector)
//   if( target ){
//     window.scrollTo({
//       top: target.offsetTop,
//       behavior: 'smooth'
//     })
//   }
// }

// function animateScrollHero(item) {
//   function getMaxSize() {
//     return Math.max(window.innerWidth, window.innerHeight) * 2 + "px"
//   }

//   let tlItem = gsap.timeline({ autoAlpha:0, height: 0, width: 0, paused: true })

//   tlItem.to(item, {
//     autoAlpha: 1,
//     width: getMaxSize(),
//     height: getMaxSize(),
//     ease: 'expo.out',
//   })

//   let lastScrollY = window.scrollY

//   ScrollTrigger.create({
//     trigger: '.section--hero',
//     start: '51% center',
//     end: '25%',
//     animation: tlItem,
//     markers: false,
//     scrub: true,
//     pin: true,
//     pinSpacing: false,
//     toggleActions: 'play none none reverse',
//     onUpdate: (self) => {
//       let currentScrollY = window.scrollY;
//       let scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
//       lastScrollY = currentScrollY;

//       console.log(' - Anchor scrolling check: ', isScrollingFromAnchor())
//       if( self.progress === 1 && scrollDirection === 'down' && !isScrollingFromAnchor() ) {
//         console.log(' - Scrolling to: section--vertical-scroll ')
//         scrollToSection('.section--vertical-scroll')
//       }
//     },
//   })
// }
// OLD ANIMATION END

function animateScrollHero(items) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({ autoAlpha: 1, scale: 100, paused: true })

    tlItem.to(item, {
      autoAlpha: 0,
      scale: 0.7,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: '.section--hero',
      start: '5% top',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      scrub: true,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateHorizontal(items, offset) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({ autoRemoveChildren: true, paused: true })

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      x: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateVertical(items, offset, start = 'top 95%') {
  items.forEach((item) => {
    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      y: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: start,
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

function animateFade(items) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}

const animateInStaggerBottom = (items) => {
  items.forEach((item) => {
    gsap.set(item, { autoAlpha: 1, y: 0 })

    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})
    let stItem = null

    // Select subitems within the main item
    const subitems = Array.from(
      item.querySelectorAll('.animate-stagger-item')
    )
    
    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity';

    if( subitems.length > 0 ){
      tlItem.from(subitems, {
        [property]: 0,
        duration: 0.75,
        y: 100,
        ease: 'Power2.easeOut',
        stagger: 0.2,
        onComplete: () => {
          stItem.kill()
          item.classList.remove('.animate-in-stagger-item')
        },
      })
  
      stItem = ScrollTrigger.create({
        trigger: item,
        start: 'top 70%',
        animation: tlItem,
        // markers: true,
        toggleActions: 'play none none none',
      })
    }
  })
}